function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "javascript_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "javascript_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#javascript_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "javascript-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "javascript-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#javascript_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.2438 34.2225C47.6377 35.749 46.8856 37.2021 46.004 38.5633C44.9061 40.2612 43.607 41.8174 42.1418 43.197C41.2836 44.0062 40.3693 44.7541 39.404 45.4357C35.3326 48.3112 30.3643 50 25 50C19.6357 50 14.6674 48.3112 10.5959 45.4357C9.3877 44.5827 8.25918 43.6266 7.22344 42.5775C2.75713 38.0622 0 31.8521 0 25C0 18.1479 2.75713 11.9378 7.22344 7.42246C8.32041 6.3123 9.52139 5.30508 10.8102 4.41533C14.8408 1.63057 19.7296 0 25 0C30.2704 0 35.1592 1.63057 39.1898 4.41533C40.1745 5.09395 41.1072 5.84287 41.9816 6.6541C43.5133 8.07041 44.8663 9.67754 46.0041 11.4367C46.8857 12.7979 47.6378 14.251 48.2439 15.7775C49.3775 18.6316 50 21.7429 50 25C50 28.2571 49.3775 31.3684 48.2438 34.2225Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(7.223633 4.415039)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.08174 4.8195C4.5251 6.48952 6.40391 7.46364 9.32647 8.43796C12.249 9.41218 14.0583 11.9869 13.7104 14.2831C13.3624 16.5793 12.3882 19.5716 6.6127 19.5716C3.00303 19.5716 0.996973 17.3154 0 15.6234L3.27256 13.6568C3.27256 13.6568 4.38594 16.0227 6.47344 16.0227C8.56104 16.0227 9.396 15.3269 9.396 13.7264C9.396 11.7781 2.64619 11.0823 1.60244 7.74216C0.558691 4.40202 1.95039 -0.329717 6.82129 0.0181344C9.86572 0.235615 11.5781 1.73054 12.4344 2.82116L9.18721 5.16745C8.49141 3.14948 5.63828 3.14948 5.08174 4.8195Z",
  transform: "translate(21.77832 13.167969)",
  id: "Vector",
  fill: "#151436",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.00225 13.3604C8.00225 14.9607 6.61055 15.7959 5.21885 15.5175C3.82715 15.2392 3.20088 13.5691 3.20088 13.5691L0 15.7263C0 15.7263 0.695801 18.9271 5.07969 19.2056C9.46357 19.4839 11.9686 16.8396 11.9686 14.6129C11.9686 12.3861 11.9686 0 11.9686 0L8.00225 0C8.00225 0 8.00225 11.7599 8.00225 13.3604Z",
  transform: "translate(7.7939453 13.53418)",
  id: "Vector",
  fill: "#151436",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 38.1622C1.03574 39.2112 2.16426 40.1673 3.37246 41.0204L32.1807 41.0204C33.146 40.3388 34.0603 39.5908 34.9185 38.7816L2.23877 38.7816L2.23877 2.23877L38.7806 2.23877L38.7806 34.1479C39.6622 32.7867 40.4143 31.3337 41.0204 29.8071L41.0204 0L0 0L0 38.1622Z",
  id: "Vector",
  fill: "#151436",
  fillRule: "evenodd",
  stroke: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.96631 7.93261C1.77578 7.93261 0 6.15684 0 3.96631C0 1.77578 1.77578 0 3.96631 0C6.15684 0 7.93262 1.77578 7.93262 3.96631C7.93262 6.15684 6.15684 7.93261 3.96631 7.93261Z",
  transform: "translate(4.6132812 29.15332)",
  id: "Vector",
  fill: "#131334",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgJavascript = function SvgJavascript(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJavascript, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/javascript.01f087e2.svg";
export { ForwardRef as ReactComponent };